// extracted by mini-css-extract-plugin
export default {"skillContainer":"Skills_skillContainer__5LzBx","skillHeader":"Skills_skillHeader__iv93I","techSkills":"Skills_techSkills__ewb8Z"};